import { render, staticRenderFns } from "./NewEnvelopeDialog.vue?vue&type=template&id=0fb3a4bc"
import script from "./NewEnvelopeDialog.vue?vue&type=script&lang=js"
export * from "./NewEnvelopeDialog.vue?vue&type=script&lang=js"
import style0 from "../../../styles/charge_dialog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports